import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteTrackingService {
  private currentTrackingData: any = null;
  
  constructor(private router: Router) {
    // Listen to route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateTrackingData();
      });
  }
  
  // used by the DocTeaserComponent to know which page type the user is on
  // and to set the traffic_source accordingly
  private updateTrackingData() {
    // Reset first
    this.currentTrackingData = { source: 'unknown' };
    
    // Get current route tree
    let route = this.router.routerState.root;
    
    // Find leaf route
    while (route.firstChild) {
      route = route.firstChild;
    }
    
    // Search for tracking data
    while (route) {
      if (route.snapshot.data && route.snapshot.data['trackingSource']) {
        this.currentTrackingData = {
          source: route.snapshot.data['trackingSource'],
          ...route.snapshot.data['trackingContext']
        };
        return;
      }
      route = route.parent;
    }
  }
  
  getCurrentTrackingData(): any {
    // Always get fresh data when requested
    this.updateTrackingData();
    return this.currentTrackingData || { source: 'unknown' };
  }
}